const MAX_LISTED_AUTHORS = 3;

/**
 * Joins an author list into a compact byline, truncating past three names.
 * Truncates the array itself, so a name that contains a comma ("Smith, John")
 * still counts as one author. Returns an empty string for no authors.
 *
 * @param authors - Author names, in byline order
 * @param etAlSuffix - Appended after the third name when truncated; the meta
 *   rows use " et al.", AMA citations use ", et al"
 */
export function formatAuthors(authors: string[] | null, etAlSuffix = ' et al.'): string {
  const names = authors?.map((author) => author.trim()).filter(Boolean) ?? [];

  if (names.length > MAX_LISTED_AUTHORS) {
    return `${names.slice(0, MAX_LISTED_AUTHORS).join(', ')}${etAlSuffix}`;
  }

  return names.join(', ');
}
